<div class="lnb">
  <h2 class="my-txt" [innerHTML]="'TERM.NAVIGATION.MY' | t">My Account</h2>
  <ul>
    <li [ngClass]="{ active: currentPage === 'ACCOUNT' }">
      <a [routerLink]="['/my/account']" [innerHTML]="'MY.MY_ACCOUNT' | t"> My Account </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'MEMBERSHIP' }">
      <a [routerLink]="['/my/membership']"> My Membership </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'COUPON' }">
      <a [routerLink]="['/my/coupon']" [innerHTML]="'TITLE.COUPON' | t"> Coupon </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'POINT' }">
      <a [routerLink]="['/my/point']" [innerHTML]="'TITLE.MY_POINT' | t"> My Point </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'CREDIT' }">
      <a [routerLink]="['/my/credit']" [innerHTML]="'TITLE.MY_CREDIT' | t"> My Credit </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'ORDER' }">
      <a [routerLink]="['/my/order']" [innerHTML]="'MY.ORDER_HISTORY' | t"> Order History </a>
    </li>
    @if (!restockAlertUiTempDisabled) {
      <li [ngClass]="{ active: currentPage === 'RESTOCK' }">
        <a [routerLink]="['/my/restock']"> Restock Alerts </a>
      </li>
    }
    <li [ngClass]="{ active: currentPage === 'INQUIRY' }">
      <a [routerLink]="['/my/inquiry']" [innerHTML]="'MY.MY_INQUIRY' | t"> My Inquiry </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'HELP' }">
      <a [routerLink]="['/my/faq']" [innerHTML]="'MY.HELP' | t"> Help/FAQ </a>
    </li>
    <li [ngClass]="{ active: currentPage === 'NOTICE' }">
      <a [routerLink]="['/my/notice']" [innerHTML]="'MY.NOTICE' | t"> Notice </a>
    </li>
  </ul>
  <button (click)="signout()" [innerHTML]="'BUTTON.SIGN_OUT' | t">sign out</button>
</div>
